import React, { useEffect, useState, useRef } from 'react';
import Input from '../components/Input';
import Button from '../components/Button';
import Text from '../components/Text';
import { Link, useNavigate } from "react-router-dom";
import axios from 'axios';
import CookieConsent, { Cookies, getCookieConsentValue , resetCookieConsentValue  } from "react-cookie-consent";
import { useCookies } from 'react-cookie';

function Signup(props) {
    const [inputs, setInputs] = useState("");
    const [validation, setValidation] = useState(null);
    const form = useRef();
    const navigate = useNavigate();

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setValidation(null)

        console.log(name, value);

        setInputs((values) => ({ ...values, [name]: value }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        axios.post(`http://localhost:5000/apiRouter/register`, {
            email: inputs.email,
            mdp: inputs.mdp,
            avatar: inputs.avatar,
            pseudo: inputs.pseudo,
            score: "0"
        })
            .then(res => {
                console.log("res", res);
                console.log("res.data", res.data);
                setValidation(true); 
            })
            .catch(function (error) {
                console.log('error',error.toJSON());
                setValidation(false)  
            });
        // navigate('/ReadWord', { replace: true })
    }

    return (
        <div className="w-login row w-fullscreen">
            <div className='col-lg-6 bg-blue w-half-left'>
                <img className="w-img-xl" src="/img/categories/login.png" alt="login" />
            </div>
            <form ref={form} onSubmit={handleSubmit} className='col-lg-6 w-half-right'>

                <img className="w-img-lg" src="/img/categories/wordin_full.png" alt="login" />
                {
                    validation === true
                    &&
                    <Link to="/login">
                        <Text text="Super ! Votre compte est prêt, connectez-vous ici ! " classes="w-text-green-light w-text-underline" />
                    </Link>
                }
                {
                    validation === false
                    &&
                    <Link to="/login">
                        <Text text="Attention ! Problème rencontré au traitement." classes="w-text-red-m" />
                    </Link>
                } 
                <Text text="Inscription" classes="w-text-blue-l" />
                <div className='row avtr'>
                    <div class="col-lg-1">
                        <input

                            onChange={handleChange}

                            type="radio" name="avatar" value="/img/players/player_a.png"
                            id="player_a" className="input-hidden" />
                        <label for="player_a">
                            <img
                                src="/img/players/player_a.png"
                                alt="I'm sad" />
                        </label>
                    </div>
                    <div class="col-lg-1">
                        <input

                            onChange={handleChange}

                            type="radio" name="avatar" value="/img/players/player_b.png"
                            id="player_b" className="input-hidden" />
                        <label for="player_b">
                            <img
                                src="/img/players/player_b.png"
                                alt="I'm sad" />
                        </label>
                    </div>

                    <div class="col-lg-1">
                        <input

                            onChange={handleChange}

                            type="radio" name="avatar" value="/img/players/player_c.png"
                            id="player_c" className="input-hidden" />
                        <label for="player_c">
                            <img
                                src="/img/players/player_c.png"
                                alt="I'm sad" />
                        </label>
                    </div>

                    <div class="col-lg-1">
                        <input

                            onChange={handleChange}

                            type="radio" name="avatar" value="/img/players/player_d.png"
                            id="player_d" className="input-hidden" />
                        <label for="player_d">
                            <img
                                src="/img/players/player_d.png"
                                alt="I'm sad" />
                        </label>
                    </div>
                    <div class="col-lg-1">
                        <input

                            onChange={handleChange}

                            type="radio" name="avatar" value="/img/players/player_e.png"
                            id="player_e" className="input-hidden" />
                        <label for="player_e">
                            <img
                                src="/img/players/player_e.png"
                                alt="I'm sad" />
                        </label>
                    </div>

                    <div class="col-lg-1">
                        <input
                            defaultChecked
                            onChange={handleChange}

                            type="radio" name="avatar" value="/img/players/player_f.png"
                            id="player_f" className="input-hidden" />
                        <label for="player_f">
                            <img
                                src="/img/players/player_f.png"
                                alt="I'm sad" />
                        </label>
                    </div>

                    <div class="col-lg-1">
                        <input

                            onChange={handleChange}

                            type="radio" name="avatar" value="/img/players/player_g.png"
                            id="player_g" className="input-hidden" />
                        <label for="player_g">
                            <img
                                src="/img/players/player_g.png"
                                alt="I'm sad" />
                        </label>
                    </div>


                    <div class="col-lg-1">
                        <input

                            onChange={handleChange}

                            type="radio" name="avatar" value="/img/players/player_h.png"
                            id="player_h" className="input-hidden" />
                        <label for="player_h">
                            <img
                                src="/img/players/player_h.png"
                                alt="I'm sad" />
                        </label>
                    </div>

                    <div class="col-lg-1">
                        <input

                            onChange={handleChange}

                            type="radio" name="avatar" value="/img/players/player_i.png"
                            id="player_i" className="input-hidden" />
                        <label for="player_i">
                            <img
                                src="/img/players/player_i.png"
                                alt="I'm sad" />
                        </label>
                    </div>

                    <div class="col-lg-1">
                        <input

                            onChange={handleChange}

                            type="radio" name="avatar" value="/img/players/player_j.png"
                            id="player_j" className="input-hidden" />
                        <label for="player_j">
                            <img
                                src="/img/players/player_j.png"
                                alt="I'm sad" />
                        </label>
                    </div>
                </div>
                <input
                    type="text"
                    placeholder="Pseudo"
                    name="pseudo"
                    value={inputs.pseudo || ""}
                    onChange={handleChange}
                    className="w-input"
                    required
                />
                <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    value={inputs.email || ""}
                    onChange={handleChange}
                    className="w-input"
                    required
                />
                <input
                    type="text"
                    placeholder="Mot de passe"
                    name="mdp"
                    value={inputs.mdp || ""}
                    onChange={handleChange}
                    className="w-input"
                    required
                />

                <Button text="Valider !" classes="w-btn-blue-lg" />

                <Link to="/login">
                    <Text text="J'ai déjà un compte. Se connecter" classes="w-text-black-m" />
                </Link>

            </form>
            <CookieConsent
                location="bottom"
                buttonText="Bien sûr !"
                cookieName="w-coockies-acceptation"
                style={{ background: "#0179bf" }}
                buttonStyle={{ color: "#0179bf", fontSize: "13px",borderRadius: "50px",background: "#fff" }}
                expires={150}
            > 
                Notre site utilise les coockies pour vous donner une meilleur expérience lors de son utilisation... <b>Avouez que c'est bon les coockies 🍪🍪🍪!</b>
                 
            </CookieConsent>
        </div>
    );
}

export default Signup;